import { type MgoObjectResponse } from '@mgonetwork/mango.js/client';
import { formatAddress } from '@mgonetwork/mango.js/utils';
import { Placeholder, Text } from '@mgonetwork/ui';

import { useResolveVideo } from '~/hooks/useResolveVideo';
import { ObjectLink } from '~/ui/InternalLink';
import { ObjectVideoImage } from '~/ui/ObjectVideoImage';
import { parseObjectType } from '~/utils/objectUtils';
import { trimStdLibPrefix } from '~/utils/stringUtils';

function Thumbnail({ obj }: { obj: MgoObjectResponse }) {
	const video = useResolveVideo(obj);
	const displayMeta = obj.data?.display?.data;
	const src = displayMeta?.image_url || '';
	const name = displayMeta?.name ?? displayMeta?.description;
	const type = trimStdLibPrefix(parseObjectType(obj));
	const id = obj.data?.objectId;
	const displayName = name || formatAddress(id!);

	return (
		<div>
			<ObjectLink
				display="flex"
				objectId={id!}
				label={
					<div className="group relative">
						<ObjectVideoImage
							disablePreview
							title={name || '--'}
							subtitle={type}
							src={src}
							video={video}
							variant="xl"
						/>
						{/*bg-white/80*/}
						<div className="defined-box absolute bottom-2 left-1/2 hidden w-10/12 -translate-x-1/2 justify-center rounded-lg  px-2 py-1 backdrop-blur group-hover:flex">
							<Text variant="subtitle/medium" color="text-success" truncate>
								{displayName}
							</Text>
						</div>
					</div>
				}
			/>
		</div>
	);
}

function ThumbnailsOnlyLoading({ limit }: { limit: number }) {
	return (
		<>
			{new Array(limit).fill(0).map((_, index) => (
				<div key={index} className="h-16 w-16 md:h-31.5 md:w-31.5">
					<Placeholder rounded="lg" height="100%" />
				</div>
			))}
		</>
	);
}

interface ThumbnailsViewViewProps {
	limit: number;
	data?: MgoObjectResponse[];
	loading?: boolean;
}

export function ThumbnailsView({ data, loading, limit }: ThumbnailsViewViewProps) {
	return (
		<div className="hidden-scroll grid grid-cols-5 gap-2 overflow-auto md:gap-4">
			{loading ? (
				<ThumbnailsOnlyLoading limit={limit} />
			) : (
				data?.map((obj) => <Thumbnail key={obj.data?.objectId} obj={obj} />)
			)}
		</div>
	);
}
